import React, { Component } from "react";
import Strings from "@my-dld/assets/strings";
import { AssetCard } from "@10x/dubai-rest-api/dist/property_registry/entity";
import { FormContainer, ShowFormOnlyIf, ShowOnlyIf } from "../Base";
import { EjariApi } from "@eres/ejari-api";
import { EjariPropertyFromApi, getEjariPropertyTypeFromTabu, getLastContract } from "@eres/ejari-api/Utils";
import { hideLoading, showLoading } from "@my-dld/utils/UIUtils";
import { EjariProperty } from "@eres/ejari-api/Entity";
import { canDoContractOperations } from "@eres/ejari-api/EjariPropertyUtil";
import { Details } from "@my-dld/components/PropertyDetails/Details";
import DetailsKV from "@eres/ejari-web/component/DetailsKV";
import { formatAppDate } from "@my-dld/utils/Utils";
import { CurrencyUtil } from "@eres/core";
import { UnitSystem } from "@my-dld/utils/UnitUtils";
import { GetMobilePropertyDetailsResponse } from "@eres/ejari-api/EjariSecurityUtil";

interface Props {
	property?: AssetCard;
	unit: UnitSystem;
}

interface State {
	property: AssetCard;
	ejariProperty?: EjariProperty;
	isEjariActive: boolean;
}

export default class PSPropertyDetail extends Component<Props, State> {
	constructor( props: Props ) {
		super( props );
		this.state = {
			property: props.property!,
			isEjariActive: false,
		};
	}

	componentDidMount(): void {
		this.loadEjari();
	}

	loadEjari() {
		const { property } = this.props;
		if ( property ) {
			const isFreeHold = property.isFreeHold || property.isLeaseHold;
			const propertyTypeId = property.propertyTypeId;
			const tabuPropertyId = property.tabuPropertyId;
			showLoading();
			const apiHandler = ( response: any ) => {
				hideLoading();
				let ejariProperty = EjariPropertyFromApi( GetMobilePropertyDetailsResponse(response) );
				if ( ejariProperty.EjariPropertyId == undefined ) {
					this.setState( {
						ejariProperty: undefined,
					} );
				} else {
					let isEjariActive;
					const lastContract = getLastContract( ejariProperty );
					if ( lastContract ) {
						isEjariActive = canDoContractOperations( lastContract );
					} else {
						isEjariActive = false;
					}
					this.setState( {
						ejariProperty: ejariProperty,
						isEjariActive: isEjariActive,
					} );
				}
			};
			const exHandler = () => {
				hideLoading();
			};
			EjariApi.getPropertyDetail( tabuPropertyId.toString(), isFreeHold, getEjariPropertyTypeFromTabu( propertyTypeId! ) )
			.then( apiHandler ).catch( exHandler );
		}
	}

	render() {
		const { isEjariActive, property, ejariProperty } = this.state;
		return (
			<ShowFormOnlyIf id={ "property" } readonly={ true } holder={ this }>
				<div className="tender-registration-form">
					<FormContainer title={ Strings.property_details }>
						<ShowOnlyIf valid={ isEjariActive }>
							<div className="mt-3 mb-3 alert alert-user-notification alert-warning">
								<div className="alert-body">
									<p className="mb-0">{ Strings.tenancy_contact }</p>
								</div>
							</div>
						</ShowOnlyIf>
						<Details data={ property } unit={ this.props.unit }/>
					</FormContainer>
					<ShowOnlyIf valid={ isEjariActive && ejariProperty !== undefined }>
						<FormContainer title={ Strings.contract_details }>
							{
								ejariProperty?.AssociatedContracts?.map( ( ( value ) => {
									return <div className="flex-grid" key={ value.ContractId + "" }>
										<DetailsKV label={ Strings.contract_number } value={ value?.ContractNumber }/>
										<DetailsKV
											label={ Strings.start_date }
											value={ formatAppDate( value?.ContractStartDate ) }/>
										<DetailsKV
											label={ Strings.end_date }
											value={ formatAppDate( value?.ContractEndDate ) }/>
										<DetailsKV
											label={ Strings.tenant_name_ar }
											value={ value?.ContractTenantNameAr }/>
										<DetailsKV
											label={ Strings.tenant_name_en_new }
											value={ value?.ContractTenantNameEn }/>
										<DetailsKV
											label={ Strings.rental_amount }
											value={ CurrencyUtil.convertValueToCurrency( value?.ContractAmount ) + " " + Strings.aed }/>
										<DetailsKV label={ Strings.status } value={ value?.ContractStatusName }/>
									</div>;
								} ) )
							}
						</FormContainer>
					</ShowOnlyIf>
				</div>
			</ShowFormOnlyIf>
		);
	}
}
